import { render } from "./UnAssignAcSupervisor.vue?vue&type=template&id=26883455"
import script from "./UnAssignAcSupervisor.vue?vue&type=script&lang=js"
export * from "./UnAssignAcSupervisor.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__